import { CountryDto } from "@cradua/data";
import { createAction, props } from "@ngrx/store";

/**
 * Load Stakeholder Reference Collection Actions
 */
export const loadStakeholder = createAction("[Stakeholder] Load Stakeholder");

export const loadStakeholderSuccess = createAction(
  "[Stakeholder] Load Stakeholder Success",
  props<{ stakeholder: any[] }>(),
);

export const loadStakeholderFailure = createAction(
  "[Stakeholder] Load Stakeholder Failure",
  props<{ error: any }>(),
);

/**
 * Add Stakeholder  to Collection Actions
 */
export const addStakeholder = createAction(
  "[Stakeholder] Add Stakeholder",
  props<{ newStakeholder: any[] }>(),
);

export const addStakeholderSuccess = createAction(
  "[Stakeholder] Add Stakeholder Success",
  props<{ newStakeholder: any[] }>(),
);

export const addStakeholderFailure = createAction(
  "[Stakeholder] Add Stakeholder Failure",
  props<{ error: any }>(),
);

/**
 * Update Stakeholder  Collection Actions
 */
export const updateStakeholder = createAction(
  "[Stakeholder] Update Stakeholder ",
  props<{ updateStakeholder: any[]; deletedData: any[] }>(),
);

export const updateStakeholderSuccess = createAction(
  "[Stakeholder] Update Stakeholder  Success",
  props<{ updateStakeholder: any[] }>(),
);

export const updateStakeholderFailure = createAction(
  "[Stakeholder] Update Stakeholder Failure",
  props<{ error: any }>(),
);

/**
 * Remove Stakeholder Collection Actions
 */
export const removeStakeholder = createAction(
  "[Stakeholder] Remove Stakeholder ",
  props<{ ids: string[] }>(),
);

export const removeStakeholderSuccess = createAction(
  "[Stakeholder] Remove Stakeholder Success",
  props<{ ids: string[] }>(),
);

export const removeStakeholderFailure = createAction(
  "[Stakeholder] Remove Stakeholder  Failure",
  props<{ error: any }>(),
);
